export default __webpack_public_path__ + "static/media/remove-icon.5be1b03d.svg";